module.exports = __webpack_public_path__ + "img/about_4.f4f62cea.png";